import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing    from "./pages/Landing";
import Assessment from "./pages/Assessment";
import Results    from "./pages/Results";
import Admin      from "./pages/Admin";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/"           element={<Landing />} />
        <Route path="/assessment" element={<Assessment />} />
        <Route path="/results"    element={<Results />} />
        <Route path="/admin"      element={<Admin />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
